/* ═══════════════════════════════════════════════════
   Shared UI for Build-Wave: Stepper + KpiRow
   ═══════════════════════════════════════════════════ */
import React from 'react';
import { Check, HelpCircle } from 'lucide-react';
import { T, CARD, BORDER, STEP_LABELS, ATTRIBUTION_DISCLOSURE, UNMEASURED_PERF_KPI_NAMES } from './constants';

export function Stepper({ currentStep }) {
  return (
    <div className="flex items-center justify-center gap-1 mb-6" data-testid="wizard-stepper">
      {STEP_LABELS.map((label, i) => {
        const num = i + 1;
        const active = currentStep === num;
        const done = currentStep > num;
        let circleStyle;
        if (done) circleStyle = { background: T, color: '#000' };
        else if (active) circleStyle = { background: `${T}20`, color: T, border: `1px solid ${T}60` };
        else circleStyle = { background: CARD, color: '#555', border: `1px solid ${BORDER}` };
        let labelColor;
        if (active) labelColor = '#fff';
        else if (done) labelColor = T;
        else labelColor = '#555';
        return (
          <React.Fragment key={label}>
            {i > 0 && <div className="w-12 h-px" style={done ? { background: T } : { background: '#1E1E1E' }} />}
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-full flex items-center justify-center text-[11px] font-bold transition-all" style={circleStyle}>
                {done ? <Check className="h-3.5 w-3.5" /> : num}
              </div>
              <span className="text-[11px] font-semibold hidden sm:inline" style={{ color: labelColor }}>{label}</span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}

export function KpiRow({ kpi, enabled, onToggle }) {
  return (
    <div className={`flex items-center gap-3 p-2.5 rounded-lg border transition-all ${enabled ? 'bg-[#0A0A0A] border-[#1E1E1E]' : 'bg-transparent border-transparent opacity-50'}`}>
      <input type="checkbox" checked={enabled} onChange={onToggle}
        className="w-3.5 h-3.5 rounded border-[#333] bg-[#0A0A0A] focus:ring-0" style={{ accentColor: T }} />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-[11px] font-semibold text-white">{kpi.name}</span>
          {kpi.required && <span className="text-[7px] px-1 py-0.5 rounded bg-red-500/15 text-red-400 font-bold uppercase">Required</span>}
          <div className="group relative">
            <HelpCircle className="h-3 w-3 text-gray-600 cursor-help" />
            <div className="absolute bottom-5 left-0 hidden group-hover:block bg-[#1a1a1a] border border-[#333] rounded-lg p-2 w-48 z-50 shadow-xl">
              <p className="text-[9px] text-gray-400">{kpi.help}</p>
            </div>
          </div>
        </div>
        <p className="text-[9px] text-gray-600">Benchmark: {kpi.benchmark}</p>
        {UNMEASURED_PERF_KPI_NAMES.includes(kpi.name) && (
          <p className="text-[8px] text-amber-400/90 leading-snug mt-0.5"
             data-testid="kpi-attribution-disclosure">
            {ATTRIBUTION_DISCLOSURE}
          </p>
        )}
      </div>
      {enabled && (
        <input type="text" placeholder="Target" className="w-20 px-2 py-1.5 rounded text-[10px] text-white placeholder-gray-600 focus:outline-none" style={{ background: '#0A0A0A', border: `1px solid ${BORDER}` }} />
      )}
    </div>
  );
}
